export default __webpack_public_path__ + "fonts/SeniorOwners-White.svg";